import {
  Component,
  OnInit,
  Inject,
  Output,
  EventEmitter,
  ElementRef,
  NgZone,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ReCaptcha2Component } from 'ngx-captcha';
import { environment } from '../../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { TextSetting } from '../../../../textsetting';
import { SignupService } from '../../service/index';
import { DataLayerService } from '../../../../_services/data-layer.service';
import {
  CommonFunctionsService,
  UserService,
  SeoService,
  ValidationService,
  NgxToasterService,
} from '../../../../_services/index';
import { MapsAPILoader } from '@agm/core';
import { ScriptService } from '../../../../_services/script.service';

declare var google: any;

import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.css'],
  providers: [
    CommonFunctionsService,
    UserService,
    SeoService,
    SignupService,
    BsModalRef,
    BsModalService,
    ScriptService,
  ],
})
export class PopupComponent implements OnInit {
  /**This is used to prevent memory leaks **/
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  /**This is used to prevent memory leaks **/

  @Output() jobSaveApply = new EventEmitter<boolean>();
  @Output() loginInitiated = new EventEmitter<boolean>();
  env = environment;
  urlLang: any = '';
  scrolled: boolean = false;
  openNav: boolean = false;
  TextSetting = TextSetting;

  config = {
    class: 'mymodal',
    ignoreBackdropClick: true,
    backdrop: true,
    centered: true,
    animated: true,
  };

  isLoading: boolean = false;
  signupJobseekersForm: FormGroup;
  signupJobseekersFormError: any = {};
  signupEmployersForm: FormGroup;
  signupEmployersFormError: any = {};
  signupResumeWriterForm: FormGroup;
  signupResumeWriterFormError: any = {};
  checkedEmployers: boolean = true;
  checkedJobseeker: boolean = true;
  checkednotification1 : any = false;
  checkednotification2 : any = false;
  notification: any = 2 ;
  checkedResumeWriter: boolean = true;
  companyLogo: any = {};
  swal = Swal;
  formFlag: boolean = true;

  progressJobseekers: boolean = false;
  progressEmployers: boolean = false;
  progressResumeWriter: boolean = false;

  fileName: any = '';
  userType: any = 'jobseeker';

  jobseekerAddressValue: any = '';
  employerAddressValue: any = '';
  resumeWriterAddressValue: any = '';

  employerPasswordValid: boolean = true;
  jobseekerPasswordValid: boolean = true;
  resumeWriterPasswordValid: boolean = true;
  matchPasswords: boolean = true;

  loginForm: FormGroup;
  loginFormError: any = {};
  loginLoading: boolean = false;

  otpSubmit: boolean = false;
  otpForm: FormGroup;
  otpFormError: any = {};

  forgotPasswordForm: FormGroup;
  forgotPasswordFormError: any = {};
  forgotPasswordLoading: boolean = false;

  resetPasswordForm: FormGroup;
  resetPasswordFormError: any = {};
  resetLoading: boolean = false;

  blogID: string = '';
  saveType: string = '';
  @ViewChild('signup', { static: true }) signup?: ElementRef<HTMLElement>;
  @ViewChild('login', { static: true }) login?: ElementRef<HTMLElement>;
  @ViewChild('verify_otp', { static: true })
  verify_otp?: ElementRef<HTMLElement>;
  @ViewChild('reset_password', { static: true })
  reset_password?: ElementRef<HTMLElement>;
  private geoCoder: any;

  @ViewChild('captchaElem') captchaElem: ReCaptcha2Component | any;
  @ViewChild('captchaEmployer') captchaEmployer: ReCaptcha2Component | any;
  @ViewChild('captchaResumeWriter') captchaResumeWriter:
    | ReCaptcha2Component
    | any;
  jobseekerCaptcha: boolean = false;
  employerCaptcha: boolean = false;
  resumeWriterCaptcha: boolean = false;
  // Declare Constructor
  constructor(
    private formBuilder: FormBuilder,
    public translate: TranslateService,
    public commonFunctionsService: CommonFunctionsService,
    public userService: UserService,
    private route: ActivatedRoute,
    public router: Router,
    private elementRef: ElementRef,
    private toasterNotification: NgxToasterService,
    private signupService: SignupService,
    private modalService: BsModalService,
    public modalRef: BsModalRef,
    public modalRef2: BsModalRef,
    public modalRef3: BsModalRef,
    public modalRef4: BsModalRef,
    public modalRef5: BsModalRef,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private scriptService: ScriptService,
    private dataLayerService: DataLayerService,
    @Inject(DOCUMENT) private document: Document
  ) {
    //initialization signup form
    this.signupJobseekersForm = this.formBuilder.group({});
    this.signupEmployersForm = this.formBuilder.group({});
    this.signupResumeWriterForm = this.formBuilder.group({});
    //initialization login form
    this.loginForm = this.formBuilder.group({});

    //initialization otp form
    this.otpForm = this.formBuilder.group({});

    //initialization forgot password form
    this.forgotPasswordForm = this.formBuilder.group({});

    //initialization reset password form
    this.resetPasswordForm = this.formBuilder.group({});
  }

  // Declare initialization
  ngOnInit(): void {
    /**This function is used to create signup form */
    this.createSignupForm();
    /**This function is used to create signup form */

    /**This function is used to create login form */
    this.createLoginForm();
    /**This function is used to create login form */

    /**This function is used to create otp form */
    this.createOtpForm();
    /**This function is used to create otp form */

    /**This function is used to create forgot password form */
    this.createForgotPasswordForm();
    /**This function is used to create forgot password form*/

    /**This function is used to create reset password form */
    this.createresetPasswordForm();
    /**This function is used to create reset password form*/
  }

  /**this function is used to get places on click */
  afterLocationClick() {
    let jobseekerLocation = document.getElementById('jobseekerLocation');
    this.mapsAPILoader.load().then(() => {
      this.geoCoder = new google.maps.Geocoder();
      const autocomplete = new google.maps.places.Autocomplete(
        jobseekerLocation,
        { types: ['(cities)'] }
      );
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          let Address = this.handleAddressChange(autocomplete.getPlace());
          this.jobseekerAddressValue =
            autocomplete.getPlace().formatted_address;
          this.signupJobseekersForm.patchValue({
            city: Address[0],
            state: Address[1],
            country: Address[2],
            location: Address[3],
          });
        });
      });
    });
  }

  /**this function is used to get places on click */
  afterLocationClick1() {
    let employerlocation = document.getElementById('employerlocation');
    this.mapsAPILoader.load().then(() => {
      this.geoCoder = new google.maps.Geocoder();
      const autocomplete = new google.maps.places.Autocomplete(
        employerlocation,
        { types: ['(cities)'] }
      );
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          let Address = this.handleAddressChange(autocomplete.getPlace());
          this.employerAddressValue = autocomplete.getPlace().formatted_address;
          this.signupEmployersForm.patchValue({
            city: Address[0],
            state: Address[1],
            country: Address[2],
            location: Address[3],
          });
        });
      });
    });
  }

  /**this function is used to get places on click */
  afterLocationClick2() {
    let resumeWriterLocation = document.getElementById('resumeWriterLocation');
    this.mapsAPILoader.load().then(() => {
      this.geoCoder = new google.maps.Geocoder();
      const autocomplete = new google.maps.places.Autocomplete(
        resumeWriterLocation,
        { types: ['(cities)'] }
      );
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          let Address = this.handleAddressChange(autocomplete.getPlace());
          this.resumeWriterAddressValue =
            autocomplete.getPlace().formatted_address;
          this.signupResumeWriterForm.patchValue({
            city: Address[0],
            state: Address[1],
            country: Address[2],
            location: Address[3],
          });
        });
      });
    });
  }
  /**this function is used to get places on click */

  /**this funcation is used to set form error variable as blank */
  blankError() {
    this.signupJobseekersFormError = {};
    this.signupEmployersFormError = {};
    this.signupResumeWriterFormError = {};
    this.loginFormError = {};
    this.forgotPasswordFormError = {};
    this.resetPasswordFormError = {};
    this.otpFormError = {};
    this.signupJobseekersForm.reset();
    this.signupEmployersForm.reset();
    this.signupResumeWriterForm.reset();
    this.loginForm.reset();
    this.forgotPasswordForm.reset();
    this.resetPasswordForm.reset();
    this.otpForm.reset();
    this.companyLogo = {};
    this.formFlag = true;
    this.resumeWriterPasswordValid = true;
    this.fileName = '';

    this.scriptService
      .cssload('popup')
      .then((data: any) => {})
      .catch((error: any) => console.log(error));
    this.scriptService
      .load('paypal')
      .then((data: any) => {})
      .catch((error: any) => console.log(error));
  }
  /**this funcation is used to set form error variable as blank */

  /**this funcation is used to set signup user type as jobseeker*/
  selectJobseeker(value: any) {
    this.employerCaptcha = false;
    this.jobseekerCaptcha = true;
    this.resumeWriterCaptcha = false;
    this.userType = value;
    this.blankError();
    this.signupJobseekersForm.patchValue({
      check: true,
    });
  }
  /**this funcation is used to set signup user type as jobseeker*/

  /**this funcation is used to set signup user type as employer*/
  selectEmployer(value: any) {
    this.jobseekerCaptcha = false;
    this.employerCaptcha = true;
    this.resumeWriterCaptcha = false;
    this.userType = value;
    this.blankError();
    this.signupEmployersForm.patchValue({
      check: true,
    });
  }
  /**this funcation is used to set signup user type as employer*/

  /**this funcation is used to set signup user type as resume writer*/
  selectResumeWriter(value: any) {
    this.jobseekerCaptcha = false;
    this.employerCaptcha = false;
    this.resumeWriterCaptcha = true;
    this.userType = value;
    this.blankError();
    this.signupResumeWriterForm.patchValue({
      check: true,
    });
  }

  /**this funcation is used to open signup form */
  openSignupForm(value: any) {
    this.userType = value;
    if (this.userType == 'jobseeker') {
      this.dataLayerService.pushEvent({
        event: 'Web_Job_seeker_enrollment_Form_Opened',
      });
      this.employerCaptcha = false;
      this.jobseekerCaptcha = true;
      this.resumeWriterCaptcha = false;
    } else if (this.userType == 'resume_writer') {
      this.resumeWriterCaptcha = true;
      this.employerCaptcha = false;
      this.jobseekerCaptcha = false;
    } else {
      this.dataLayerService.pushEvent({
        event: 'Web_recruiter_registration_Form_Opened',
      });
      this.jobseekerCaptcha = false;
      this.employerCaptcha = true;
      this.resumeWriterCaptcha = false;
    }
    this.openSignup(this.signup);
  }
  /**this funcation is used to open signup form */

  /**this function is used to open login form */
  openLoginForm(value: any) {
    this.userType = value;
    this.openLogin(this.login);
  }
  /**this function is used to open login form */

  /**this function is used to open login form when user click on click save job icon*/
  openLoginFormSave(value: any, blog_id: any, save_type: any) {
    this.userType = value;
    this.blogID = blog_id;
    this.saveType = save_type;
    this.openLoginSaveJob(this.login);
  }
  /**this function is used to open login form when user click on click save job icon*/

  /**this function is used to open signup form*/
  openSignup(template: TemplateRef<any> | any) {
    localStorage.setItem('page_type', 'signup');
    this.blankError();
    this.closeModal();
    this.signupJobseekersForm.patchValue({
      check: true,
    });
    this.signupEmployersForm.patchValue({
      check: true,
    });
    this.signupResumeWriterForm.patchValue({
      check: true,
    });
    let that = this;
    setTimeout(() => {
      that.modalRef = that.modalService.show(template, {
        id: 1,
        class: 'mymodal',
        ignoreBackdropClick: true,
        backdrop: true,
        animated: true,
      });
    }, 500);
  }
  /**this function is used to open signup form*/

  /**this function is used to open login form*/
  openLogin(template: TemplateRef<any> | any) {
    this.blankError();
    this.closeModal();
    let that = this;
    setTimeout(() => {
      that.modalRef2 = that.modalService.show(template, {
        id: 2,
        class: 'mymodal',
        ignoreBackdropClick: true,
        backdrop: true,
        animated: true,
      });
    }, 500);
  }
  /**this function is used to open login form*/

  /**this function is used to open login form when user click on click save job icon*/
  openLoginSaveJob(template: TemplateRef<any> | any) {
    this.blankError();
    let that = this;
    setTimeout(() => {
      that.modalRef2 = that.modalService.show(template, {
        id: 2,
        class: 'mymodal',
        ignoreBackdropClick: true,
        backdrop: true,
        animated: true,
      });
    }, 500);
  }
  /**this function is used to open login form when user click on click save job icon*/

  /**this funcation is used to open forgot password modal */
  openForgotPassword(template: TemplateRef<any>) {
    localStorage.setItem('page_type', 'forgot_type');
    this.blankError();
    this.closeModal();
    let that = this;
    setTimeout(() => {
      that.modalRef3 = that.modalService.show(template, {
        id: 3,
        class: 'mymodal',
        ignoreBackdropClick: true,
        backdrop: true,
        animated: true,
      });
    }, 500);
  }
  /**this funcation is used to open forgot password modal */

  /**this funcation is used to open reset modal */
  openResetOtp(template: TemplateRef<any> | any) {
    this.blankError();
    this.closeModal();
    let that = this;
    setTimeout(() => {
      that.modalRef4 = that.modalService.show(template, {
        id: 4,
        class: 'mymodal',
        ignoreBackdropClick: true,
        backdrop: true,
        animated: true,
      });
    }, 500);
  }
  /**this funcation is used to open reset modal */

  /**this funcation is used to open reset password modal */
  openResetPassword(template: TemplateRef<any> | any) {
    this.blankError();
    this.closeModal();
    let that = this;
    setTimeout(() => {
      that.modalRef5 = that.modalService.show(template, {
        id: 5,
        class: 'mymodal',
        ignoreBackdropClick: true,
        backdrop: true,
        animated: true,
      });
    }, 500);
  }
  /**this funcation is used to open reset password modal */

  /**this funcation is used to close modal */
  closeModal(modalId?: number) {
    this.blogID = '';
    this.saveType = '';
    this.blankError();
    this.modalService.hide(modalId);
  }
  /**this funcation is used to close modal */

  /** this function is used to blank the set address variable bank on keyup*/
  public changeValueJobseeker() {
    this.jobseekerAddressValue = '';
  }
  /** this function is used to blank the set address variable bank on keyup*/

  /** this function is used to set the address bank if address variable is blank*/
  public changeAddressJobseeker() {
    if (this.jobseekerAddressValue == '') {
      this.signupJobseekersForm.patchValue({
        location: '',
      });
    }
  }
  /** this function is used to set the address bank if address variable is blank*/

  public changeValueResumeWriter() {
    this.resumeWriterAddressValue = '';
  }
  /** this function is used to blank the set address variable bank on keyup*/

  /** this function is used to set the address bank if address variable is blank*/
  public changeAddressResumeWriter() {
    if (this.resumeWriterAddressValue == '') {
      this.signupResumeWriterForm.patchValue({
        location: '',
      });
    }
  }

  /** this function is used to blank the set address variable bank on keyup*/
  public changeValueEmployer() {
    this.employerAddressValue = '';
  }
  /** this function is used to blank the set address variable bank on keyup*/

  /** this function is used to set the address bank if address variable is blank*/
  public changeAddressEmployer() {
    if (this.employerAddressValue == '') {
      this.signupEmployersForm.patchValue({
        location: '',
      });
    }
  }
  /** this function is used to set the address bank if address variable is blank*/

  /** this function is used to handle the address form */
  public handleAddressChange(address: any): any {
    let whole_address = address.address_components;
    let that = this;
    let cityName,
      stateName,
      countryName,
      locality = '';
    let latitude = address.geometry.location.lat();
    let longitude = address.geometry.location.lng();
    whole_address.forEach((value1: any) => {
      //some of cities change the google indexing value.
      if (
        value1.types[0] == 'locality' ||
        value1.types[1] == 'locality' ||
        value1.types[2] == 'locality'
      ) {
        let prev_long_name_city = value1.long_name;
        cityName = prev_long_name_city;
      }

      if (value1.types[0] == 'administrative_area_level_1') {
        let prev_long_name_state = value1.long_name;
        stateName = prev_long_name_state;
      }

      if (value1.types[0] == 'country') {
        let prev_long_name_country = value1.long_name;
        countryName = prev_long_name_country;
      }
    });
    locality = address.formatted_address;
    return [cityName, stateName, countryName, locality, latitude, longitude];
  }
  /** this function is used to handle the address form */

  /** this function is used to create signup form */
  public createSignupForm(): void {
    this.signupJobseekersForm = this.formBuilder.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      email: ['', [Validators.required, ValidationService.emailValidator]],
      mobile_number: [''],
      location: [''],
      country: [''],
      state: [''],
      city: [''],
      password: [
        '',
        [Validators.required, ValidationService.passwordSixValidator],
      ],
      confirm_password: [
        '',
        [Validators.required, ValidationService.passwordSixValidator],
      ],
      check: [true, Validators.required],
      recaptcha: ['',Validators.required],
      notification: [2], 
    });

    this.signupResumeWriterForm = this.formBuilder.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      email: ['', [Validators.required, ValidationService.emailValidator]],
      mobile_number: [''],
      country: [''],
      state: [''],
      city: [''],
      password: [
        '',
        [Validators.required, ValidationService.passwordSixValidator],
      ],
      confirm_password: [
        '',
        [Validators.required, ValidationService.passwordSixValidator],
      ],
      check: [true, Validators.required],
      notification: [2], 
      recaptcha: ['', Validators.required],
    });

    this.signupEmployersForm = this.formBuilder.group({
      user_type: [''],
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      email: ['', [Validators.required, ValidationService.emailValidator]],
      mobile_number: [''],
      country: [''],
      state: [''],
      city: [''],
      password: [
        '',
        [Validators.required, ValidationService.passwordSixValidator],
      ],
      confirm_password: [
        '',
        [Validators.required, ValidationService.passwordSixValidator],
      ],
      company_name: ['', Validators.required],
      company_website: [''],
      image: [''],
      check: [true, Validators.required],
      notification: [2], 
      recaptcha: ['',Validators.required],
    });
  }
  /** this function is used to create signup form */

  /** If captcha expired */
  handleExpire(): void {
    this.captchaElem.resetCaptcha();
  }
  /** If captcha expired */
  /** If captcha expired Employer form*/
  handleExpireCaptchaEmployer(): void {
    this.captchaEmployer.resetCaptcha();
  }
  handleExpireCaptchaResumeWriter(): void {
    this.captchaResumeWriter.resetCaptcha();
  }
  /** If captcha expired */

  /**this function is called jobseeker signup checkbox value changed */
  public onCheckedJobseekerChanged(value: any) {
    this.checkedJobseeker = !this.checkedJobseeker;
    if (this.checkedJobseeker) {
      this.signupJobseekersForm.patchValue({
        check: this.checkedJobseeker,
      });
    } else {
      this.signupJobseekersForm.patchValue({
        check: null,
      });
    }
  }

  public onCheckedallownotification1(value: any) {
    this.checkednotification1 = !this.checkednotification1;
    if (this.checkednotification1) {
      this.signupJobseekersForm.patchValue({
        notification: 1,
      });
    } else {
      this.signupJobseekersForm.patchValue({
        notification: 2,
      });
    }
  }
  /**this function is called jobseeker signup checkbox value changed */

  /**this function is called employer signup checkbox value changed */
  public onCheckedEmployersChanged(value: any) {
    this.checkedEmployers = !this.checkedEmployers;
    if (this.checkedEmployers) {
      this.signupEmployersForm.patchValue({
        check: this.checkedEmployers,
      });
    } else {
      this.signupEmployersForm.patchValue({
        check: null,
      });
    }
  }


  public onCheckedallownotification2(value: any) {
    this.checkednotification2 = !this.checkednotification2;
    if (this.checkednotification2) {
      this.signupEmployersForm.patchValue({
        notification: 1,
      });
    } else {
      this.signupEmployersForm.patchValue({
        notification: 2,
      });
    }
  }
  /**this function is called employer signup checkbox value changed */

  public onCheckedResumeWriterChanged(value: any) {
    this.checkedResumeWriter = !this.checkedResumeWriter;
    if (this.checkedResumeWriter) {
      this.signupResumeWriterForm.patchValue({
        check: this.checkedResumeWriter,
      });
    } else {
      this.signupResumeWriterForm.patchValue({
        check: null,
      });
    }
  }

  /**submit form on enter key*/
  public signupJobseekersFormSubmit(event: any) {
    if (event.keyCode === 13) {
      this.submitSignupJobseekersForm();
    }
  }
  public signupEmployersFormSubmit(event: any) {
    if (event.keyCode === 13) {
      this.submitSignupEmployersForm();
    }
  }
  public signupResumeWriterFormSubmit(event: any) {
    if (event.keyCode === 13) {
      this.submitSignupResumeWriterForm();
    }
  }
  public loginFormSubmit(event: any) {
    if (event.keyCode === 13) {
      this.checkLogin();
    }
  }
  public forgotPasswordFormSubmit(event: any) {
    if (event.keyCode === 13) {
      this.forgotPassword();
    }
  }
  public resetPasswordFormSubmit(event: any) {
    if (event.keyCode === 13) {
      this.resetPassword();
    }
  }
  public otpFormSubmit(event: any) {
    if (event.keyCode === 13) {
      this.submitOtp();
    }
  }
  /**submit form on enter key*/

  /** this function is used to check confirm password & password value */
  public employerPassword() {
    let password = this.signupEmployersForm.value.password;
    let cpassword = this.signupEmployersForm.value.confirm_password;
    if (password !== '' && cpassword !== '' && password !== cpassword) {
      this.employerPasswordValid = false;
    } else {
      this.employerPasswordValid = true;
    }
  }

  public jobseekerPassword() {
    const password = this.signupJobseekersForm.value.password;
    const cpassword = this.signupJobseekersForm.value.confirm_password;
    if (password !== '' && cpassword !== '' && password !== cpassword) {
      this.jobseekerPasswordValid = false;
    } else {
      this.jobseekerPasswordValid = true;
    }
  }

  public resumeWriterPassword() {
    const password = this.signupResumeWriterForm.value.password;
    const cpassword = this.signupResumeWriterForm.value.confirm_password;
    if (
      password !== '' &&
      cpassword !== '' &&
      cpassword.length >= 6 &&
      password !== cpassword
    ) {
      this.resumeWriterPasswordValid = false;
    } else {
      this.resumeWriterPasswordValid = true;
    }
  }

  public matchPassword() {
    const password = this.resetPasswordForm.value.password;
    const cpassword = this.resetPasswordForm.value.confirm_password;
    if (password !== '' && cpassword !== '' && password !== cpassword) {
      this.matchPasswords = false;
    } else {
      this.matchPasswords = true;
    }
  }

  /** this function is used to check confirm password & password value */

  /**this funcation is used to submit jobseeker signup form */
  public submitSignupResumeWriterForm() {
    this.progressResumeWriter = true;
    console.log(this.signupResumeWriterForm.value);
    if (this.signupResumeWriterForm.valid && this.resumeWriterPasswordValid) {
      let formData: any = {};
      formData['data'] = { ...this.signupResumeWriterForm.value };
      formData['data']['user_type'] = 'resume_writer';
      this.signupService
        .submitUserSignupDetail(formData['data'])
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((response: any) => {
          if (response.status === this.env.SUCCESS_STATUS) {
            this.progressResumeWriter = false;
            this.toasterNotification.showSuccess(response.message);
            this.signupResumeWriterForm.reset();
            this.signupResumeWriterFormError = {};
            localStorage.setItem('user_id', response.result.user_id);
            this.closeModal();
            let that = this;
            setTimeout(() => {
              that.openResetOtp(that.verify_otp);
            }, 500);
          } else {
            if (
              response.errors !== undefined &&
              response.errors !== '' &&
              response.errors !== null
            ) {
              this.signupResumeWriterFormError = response.errors;
            } else {
              this.toasterNotification.showError(response.message);
            }
            this.progressResumeWriter = false;
          }
        });
    } else {
      this.progressResumeWriter = false;
      ValidationService.validateAllFormFields(this.signupResumeWriterForm);
    }
  }

  /**this funcation is used to submit jobseeker signup form */
  public submitSignupJobseekersForm() {
    this.progressJobseekers = true;

    if (this.signupJobseekersForm.valid && this.jobseekerPasswordValid) {
      let formData: any = {};
      formData['data'] = { ...this.signupJobseekersForm.value };
      formData['data']['user_type'] = 'jobseeker';
      this.signupService
        .submitUserSignupDetail(formData['data'])
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((response: any) => {
          if (response.status === this.env.SUCCESS_STATUS) {
            this.progressJobseekers = false;
            this.toasterNotification.showSuccess(response.message);
            this.signupJobseekersForm.reset();
            this.signupJobseekersFormError = {};
            localStorage.setItem('user_id', response.result.user_id);
            this.closeModal();

            this.dataLayerService.pushEvent({
              event: 'Web_Job_seeker_enrollment_Form_Completed',
            });

            let that = this;
            setTimeout(() => {
              that.openResetOtp(that.verify_otp);
            }, 500);
          } else {
            if (
              response.errors !== undefined &&
              response.errors !== '' &&
              response.errors !== null
            ) {
              this.signupJobseekersFormError = response.errors;
            } else {
              this.toasterNotification.showError(response.message);
            }
            this.progressJobseekers = false;
          }
        });
    } else {
      this.progressJobseekers = false;
      ValidationService.validateAllFormFields(this.signupJobseekersForm);
    }
  }
  /**this funcation is used to submit jobseeker signup form */

  /**This function are used for upload company image **/
  fileChangeEvent(event: any): void {
    let files = event.target.files;
    let imageValid = ValidationService.validateImageExtension(files);
    if (imageValid['status'] == true) {
      let file = event.target.files[0];
      this.formFlag = true;
      this.signupEmployersForm.value.image = file;
      this.signupEmployersFormError.image = '';
      this.companyLogo = file;
      this.fileName = file.name;
    } else {
      if (files.length > 0) {
        this.signupEmployersFormError['image'] = imageValid['message'];
      } else {
        this.signupEmployersFormError['image'] = '';
      }
      this.formFlag = false;
      this.signupEmployersForm.value.image = null;
      this.companyLogo = {};
      this.fileName = '';
    }
  }
  /**This function are used for upload company image **/

  /* FUNCTION TO PREPARE FORM BEFOR SUBMIT WITH ALL DATA & IMAGE ALSO */
  private prepareSave(): any {
    let input: any = {};
    input['data'] = { ...this.signupEmployersForm.value };
    input['data']['user_type'] = 'recruiter';
    input['image'] = this.companyLogo;
    return input;
  }
  /*############################END FUNCTIONS FOR IMAGE UPLOAD################### */

  /**this funcation is used to submit employer signup form */
  public submitSignupEmployersForm() {
    console.log(
      this.signupEmployersForm.valid,
      this.formFlag,
      this.employerPasswordValid,
      'PassVa'
    );
    this.progressEmployers = true;

    if (
      this.signupEmployersForm.valid &&
      this.formFlag &&
      this.employerPasswordValid
    ) {
      const formData = this.prepareSave();
      this.signupService
        .submitUserSignupDetails(formData)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((response: any) => {
          if (response.status === this.env.SUCCESS_STATUS) {
            this.progressEmployers = false;
            this.toasterNotification.showSuccess(response.message);
            this.signupEmployersForm.reset();
            this.signupEmployersFormError = {};
            localStorage.setItem('user_id', response.result.user_id);
            this.dataLayerService.pushEvent({
              event: 'Web_recruiter_registration_Form_Completed', // Replace with your custom event name
              someCustomData: 'Custom data you want to pass',
            });
            this.closeModal();
            let that = this;
            setTimeout(() => {
              that.openResetOtp(that.verify_otp);
            }, 500);
          } else {
            if (
              response.errors !== undefined &&
              response.errors !== '' &&
              response.errors !== null
            ) {
              this.signupEmployersFormError = response.errors;
            } else {
              this.toasterNotification.showError(response.message);
            }
            this.progressEmployers = false;
          }
        });
    } else {
      this.progressEmployers = false;
      ValidationService.validateAllFormFields(this.signupEmployersForm);
    }
  }
  /**this funcation is used to submit employer signup form */

  /** this function is used to create login form */
  public createLoginForm(): void {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, ValidationService.emailValidator]],
      password: ['', Validators.required],
    });
  }
  /** this function is used to create login form */

  /**this funcation is used to submit login details*/
  public checkLogin() {
    this.loginLoading = true;
    if (this.loginForm.valid) {
      let formData = { ...this.loginForm.value };
      this.signupService
        .login(formData)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((response: any) => {
          if (response.status === this.env.SUCCESS_STATUS) {
            this.loginLoading = false;
            if (response.result.is_verified) {
              this.toasterNotification.showSuccess(response.message);
              this.loginForm.reset();
              this.loginFormError = {};
              console.log(
                response.result._id,
                'kkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk'
              );
              localStorage.setItem('storedid', response.result._id);
              let loginUserToken = response.token;
              let loginUserRefreshToken = response.refresh_token;
              let tokenExpireTime = response.token_life;
              this.userService.setAuth(response.result);
              this.userService.setToken(loginUserToken);
              this.userService.setRefreshToken(loginUserRefreshToken);
              this.userService.setTokenLife(tokenExpireTime);
              this.redirectAfterLogin(response.result);
            } else {
              this.toasterNotification.showError(response.message);
              this.closeModal();
              localStorage.setItem('user_id', response.result.user_id);
              localStorage.setItem('page_type', 'signup');
              let that = this;
              setTimeout(() => {
                that.openResetOtp(that.verify_otp);
              }, 500);
            }
          } else {
            if (
              response.errors !== undefined &&
              response.errors !== '' &&
              response.errors !== null
            ) {
              this.loginFormError = response.errors;
            } else {
              this.toasterNotification.showError(response.message);
            }
            this.loginLoading = false;
          }
        });
    } else {
      this.loginLoading = false;
      ValidationService.validateAllFormFields(this.loginForm);
    }
  }
  /**this funcation is used to submit login details*/

  /**function is used to redirect after login */
  redirectAfterLogin(userData: any) {
    this.commonFunctionsService.isBrowser.subscribe((isBrowser) => {
      if (isBrowser) {
        if (userData.recruiter) {
          this.closeModal();
          if (
            userData.membership_details == undefined ||
            Object.keys(userData.membership_details).length < 1
          ) {
            this.router.navigate(['/subscription_plan']);
          } else {
            this.router.navigate(['/employer/profile']);

            // afterpayment integration
            // this.router.navigate(['/employer']);
          }
        }
        if (userData.resume_writer) {
          this.closeModal();
          this.router.navigate(['/resume-writer']);
        }
        if (userData.jobseeker) {
          if (this.blogID != '') {
            let req: any = {};
            req['data'] = {};
            req['data']['user_id'] = this.userService.getCurrentUser()._id;
            this.signupService
              .getWishlistJobs(req['data'])
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe((response: any) => {
                if (response.status == this.env.SUCCESS_STATUS) {
                  if (
                    response.wishlist_job.indexOf(this.blogID) == -1 &&
                    this.saveType == 'job'
                  ) {
                    let ID = this.blogID;
                    this.closeModal();
                    let req: any = {};
                    req['data'] = {};
                    req['data']['user_id'] = userData._id;
                    req['data']['job_id'] = ID;
                    this.signupService
                      .saveWishlistJobs(req['data'])
                      .pipe(takeUntil(this.ngUnsubscribe))
                      .subscribe((response: any) => {
                     
                        this.jobSaveApply.emit(true);
                        if (response.status == this.env.SUCCESS_STATUS) {
                          this.toasterNotification.showSuccess(
                            response.message
                          );
                          this.blogID = '';
                          this.saveType = '';
                        }
                      });
                  } else if (
                    response.job_applied.indexOf(this.blogID) == -1 &&
                    this.saveType == 'apply'
                  ) {
                    this.closeModal();
                    this.swal
                      .fire({
                        text: 'Are you sure you want to apply in this job ?',
                        showCancelButton: true,
                      })
                      .then((result: any) => {
                        if (result.value) {
                          let ID = this.blogID;
                          let req: any = {};
                          req['data'] = {};
                          req['data']['user_id'] = userData._id;
                          req['data']['job_id'] = ID;
                          this.signupService
                            .appliedJob(req['data'])
                            .pipe(takeUntil(this.ngUnsubscribe))
                            .subscribe((response: any) => {
                              if (response.status == this.env.SUCCESS_STATUS) {
                                console.log(response,"k88888888888888888888888888888888888888888")
                                this.toasterNotification.showSuccess(
                                  response.message
                                );
                                this.blogID = '';
                                this.saveType = '';
                              }
                            });
                        } else {
                          this.blogID = '';
                          this.saveType = '';
                          this.closeModal();
                          this.jobSaveApply.emit(true);
                        }
                      });
                  } else {
                    this.blogID = '';
                    this.saveType = '';
                    this.closeModal();
                    this.jobSaveApply.emit(true);
                  }
                } else {
                  this.blogID = '';
                  this.saveType = '';
                  this.closeModal();
                }
              });
          } else if (this.router.url.indexOf('resumes') != -1) {
            this.loginInitiated.emit(true);
            this.closeModal();
          } else if (this.router.url.indexOf('resume_writers') != -1) {
            this.loginInitiated.emit(true);
            this.closeModal();
          } else {
            this.closeModal();

        
            if (userData.is_profile_complete === 1) {
                this.router.navigate(['/jobseeker']);
            } else {
                this.router.navigate(['/jobseeker/profile']);
            }
        }
        
        }
      }
    });
  }
  /**function is used to redirect after login */

  /**function is used to create otp form*/
  public createOtpForm(): void {
    this.otpForm = this.formBuilder.group({
      otp: ['', Validators.required],
    });
  }
  /**function is used to create otp form*/

  /**this function is used to submit otp */
  public submitOtp() {
    this.otpSubmit = true;
    if (this.otpForm.valid) {
      let user_id = localStorage.getItem('user_id')
        ? localStorage.getItem('user_id')
        : 0;
      let page_ytpe = localStorage.getItem('page_type');
      let formData = { ...this.otpForm.value };
      if (localStorage.getItem('page_type') == 'signup') {
        formData['page'] = 'verify_account';
        formData['user_id'] = user_id;
      } else {
        formData['page'] = 'forgot_password';
        formData['user_id'] = user_id;
      }
      this.signupService
        .submitOtp(formData)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((response: any) => {
          if (response.status === this.env.SUCCESS_STATUS) {
            this.otpSubmit = false;
            this.toasterNotification.showSuccess(response.message);
            this.otpForm.reset();
            this.otpFormError = {};
            if (localStorage.getItem('page_type') == 'forgot_type') {
              let that = this;
              setTimeout(() => {
                that.openResetPassword(that.reset_password);
              }, 500);
            } else {
              let loginUserToken = response.token;
              let loginUserRefreshToken = response.refresh_token;
              let tokenExpireTime = response.token_life;
              this.userService.setAuth(response.result);
              this.userService.setToken(loginUserToken);
              this.userService.setRefreshToken(loginUserRefreshToken);
              this.userService.setTokenLife(tokenExpireTime);
              localStorage.removeItem('user_id');
              localStorage.removeItem('page_type');
              this.closeModal();
      
              if (response.result.recruiter) {
                if (
                  response.result.membership_details == undefined ||
                  Object.keys(response.result.membership_details).length < 1
                ) {
                  this.router.navigate(['/subscription_plan']);
                } else {
                  this.router.navigate(['/employer/profile']);
                }
              } else if (response.result.resume_writer) {
                this.router.navigate(['/resume-writer']);
              } else {

                this.router.navigate(['/jobseeker/profile']);
              }
            }
          } else {
            if (
              response.errors !== undefined &&
              response.errors !== '' &&
              response.errors !== null
            ) {
              this.otpFormError = response.errors;
            } else {
              this.toasterNotification.showError(response.message);
            }
            this.otpSubmit = false;
          }
        });
    } else {
      this.otpSubmit = false;
      ValidationService.validateAllFormFields(this.otpForm);
    }
  }
  /**this function is used to submit otp */

  /**this function is used to resend otp */
  public resendOtp() {
    let user_id = localStorage.getItem('user_id')
      ? localStorage.getItem('user_id')
      : 0;
    let formData: any = {};
    if (localStorage.getItem('page_type') == 'signup') {
      formData['page'] = 'verify_account';
      formData['user_id'] = user_id;
    } else {
      formData['page'] = 'forgot_password';
      formData['user_id'] = user_id;
    }
    this.signupService
      .resendOtp(formData)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((response: any) => {
        if (response.status === this.env.SUCCESS_STATUS) {
          this.toasterNotification.showSuccess(response.message);
        } else {
          this.toasterNotification.showError(response.message);
        }
      });
  }
  /**this function is used to resend otp */

  /** this function is used to create forgot password form */
  public createForgotPasswordForm(): void {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, ValidationService.emailValidator]],
    });
  }
  /** this function is used to create forgot password form */

  /**this function is used for forgot password*/
  public forgotPassword() {
    this.isLoading = true;
    if (this.forgotPasswordForm.valid) {
      let formData = { ...this.forgotPasswordForm.value };
      this.signupService
        .forgotPassword(formData)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((response: any) => {
          if (response.status === this.env.SUCCESS_STATUS) {
            localStorage.setItem('user_id', response.user_id);
            this.isLoading = false;
            this.toasterNotification.showSuccess(response.message);
            this.forgotPasswordForm.reset();
            this.forgotPasswordFormError = {};
            this.closeModal();
            this.openResetOtp(this.verify_otp);
          } else {
            if (
              response.errors !== undefined &&
              response.errors !== '' &&
              response.errors !== null
            ) {
              this.forgotPasswordFormError = response.errors;
            } else {
              this.toasterNotification.showError(response.message);
            }
            this.isLoading = false;
          }
        });
    } else {
      this.isLoading = false;
      ValidationService.validateAllFormFields(this.forgotPasswordForm);
    }
  }

  /** this function is used to create reset password form */
  public createresetPasswordForm(): void {
    this.resetPasswordForm = this.formBuilder.group({
      password: ['', [Validators.required]],
      confirm_password: ['', [Validators.required]],
    });
  }
  /** this function is used to create reset password form */

  /** this function is used to reset password*/
  public resetPassword() {
    this.resetLoading = true;
    if (this.resetPasswordForm.valid && this.matchPasswords) {
      let formData: any = {};
      formData = { ...this.resetPasswordForm.value };
      formData['user_id'] = localStorage.getItem('user_id')
        ? localStorage.getItem('user_id')
        : 0;
      this.signupService
        .resetPassword(formData)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((response: any) => {
          if (response.status === this.env.SUCCESS_STATUS) {
            this.resetLoading = false;
            this.toasterNotification.showSuccess(response.message);
            this.resetPasswordForm.reset();
            this.resetPasswordFormError = {};
            localStorage.removeItem('user_id');
            localStorage.removeItem('page_type');
            this.closeModal();
            this.openLogin(this.login);
            this.router.navigate(['/']);
          } else {
            if (
              response.errors !== undefined &&
              response.errors !== '' &&
              response.errors !== null
            ) {
              this.resetPasswordFormError = response.errors;
            } else {
              this.toasterNotification.showError(response.message);
            }
            this.resetLoading = false;
          }
        });
    } else {
      this.resetLoading = false;
      ValidationService.validateAllFormFields(this.resetPasswordForm);
    }
  }
  /** this function is used to reset password*/

  /**This function are used for destroy the data**/
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
  }
  /**This function are used for destroy the data**/
}
